export enum AttachmentTypeCategoryEnum {
  CONTRACT = 'CONTRACT',
  COVERING_LETTER = 'COVERING_LETTER',
  INFORMATION_LETTER = 'INFORMATION_LETTER',
  PAYMENT_ORDER = 'PAYMENT_ORDER',
  OTHER = 'OTHER',
  FINANCIAL_CONTROL = 'FINANCIAL_CONTROL',
  PRELIMINARY_PAYMENT_ORDER = 'PRELIMINARY_PAYMENT_ORDER',
}

export const documentTypeCategoryOptions = [
  {
    id: AttachmentTypeCategoryEnum.CONTRACT,
    name: 'Návrh smlouvy',
  },
  {
    id: AttachmentTypeCategoryEnum.COVERING_LETTER,
    name: 'Průvodní dopis',
  },
  {
    id: AttachmentTypeCategoryEnum.INFORMATION_LETTER,
    name: 'Informační dopis',
  },
  {
    id: AttachmentTypeCategoryEnum.PAYMENT_ORDER,
    name: 'Platební příkaz',
  },
  {
    id: AttachmentTypeCategoryEnum.OTHER,
    name: 'Ostatní',
  },
  {
    id: AttachmentTypeCategoryEnum.FINANCIAL_CONTROL,
    name: 'Finanční kontrola před vznikem závazku',
  },
  {
    id: AttachmentTypeCategoryEnum.PRELIMINARY_PAYMENT_ORDER,
    name: 'Proforma platebního příkazu',
  },
];
